import { IOperatorInfo } from '../Types/ConditionOperatorTypes';
import {
  CondOperatorType,
  ExtendedOperatorType,
} from '../../../../../../../Types/ClientModelTypes';

export const conditionOperators: {
  [key in CondOperatorType | ExtendedOperatorType]: IOperatorInfo;
} = {
  starts: {
    name: 'börjar på',
    valueLabel: 'börjar på',
    toValueLabel: '',
    symbol: 'A...',
  },
  notstarts: {
    name: 'börjar inte på',
    valueLabel: 'börjar inte på',
    toValueLabel: '',
    symbol: '!A...',
  },
  contains: {
    name: 'innehåller',
    valueLabel: 'innehåller',
    toValueLabel: '',
    symbol: '..A..',
  },
  notcontains: {
    name: 'innehåller inte',
    valueLabel: 'innehåller inte',
    toValueLabel: '',
    symbol: '!..A..',
  },
  equals: {
    name: 'lika med',
    valueLabel: 'lika med',
    toValueLabel: '',
    symbol: '=A',
  },
  notequals: {
    name: 'inte lika med',
    valueLabel: 'inte lika med',
    toValueLabel: '',
    symbol: '!A',
  },
  interval: {
    name: 'intervall',
    valueLabel: 'intervall från',
    toValueLabel: 'intervall till',
    symbol: 'A-B',
  },
  notinterval: {
    name: 'utanför intervall',
    valueLabel: 'utanför intervall från',
    toValueLabel: 'utanför intervall till',
    symbol: '!A-B',
  },
  notless: {
    name: 'större än eller lika med',
    valueLabel: 'större än eller lika med',
    toValueLabel: '',
    symbol: '>=A',
  },
  greater: {
    name: 'större än',
    valueLabel: 'större än',
    toValueLabel: '',
    symbol: '>A',
  },
  notgreater: {
    name: 'mindre än eller lika med',
    valueLabel: 'mindre än eller lika med',
    toValueLabel: '',
    symbol: '<=A',
  },
  less: {
    name: 'mindre än',
    valueLabel: 'mindre än',
    toValueLabel: '',
    symbol: '<A',
  },
  hasvalue: {
    name: 'har värde',
    valueLabel: 'har värde',
    toValueLabel: '',
    symbol: '=?',
  },
  isnull: {
    name: 'saknar värde',
    valueLabel: 'saknar värde',
    toValueLabel: '',
    symbol: '-',
  },
  all: {
    name: 'alla',
    valueLabel: '',
    toValueLabel: '',
    symbol: 'A',
  },
  exists: {
    name: 'finns',
    valueLabel: '',
    toValueLabel: '',
    symbol: '=',
  },
  notexists: {
    name: 'finns inga',
    valueLabel: '',
    toValueLabel: '',
    symbol: '!=',
  },
  active: {
    name: 'aktivt',
    valueLabel: '',
    toValueLabel: '',
    symbol: '+',
  },
};
